import React from "react";
import { Mobile, Desktop } from "../../../media-queries/MediaQueries";
import LinkWrapper from "../../Global/LinkWrapper";
import ErrorComponent from "../../Common/ErrorComponent/ErrorComponent";
import Image from "../../Global/Image/Image";
import { GLOBAL_PROPS } from "../../Global/GlobalConstants";
import { DISPLAYMODE } from "../SearchToolbar/DisplayMode";
import SearchCard from "./SearchCard";
import "./MaterialCard.scss";

function MaterialAttribute({ checked = false, label = "" }) {
  return (
    <>
      {checked && (
        <div
          className={`material-card__body__material-attributes__item bold-medium ${
            checked ? "material-card__body__material-attributes__item--checked bold-bold" : ""
          }`}
        >
          <span className="darticon-checkmark material-card__body__material-attributes__item__checkmark" />
          {label}
        </div>
      )}
    </>
  );
}

function MaterialIcon({ name = "" }) {
  return (
    <li className="material-card__body__material-type-icons__item">
      <span className={`dart${name}`} aria-label={name} title={name} role="img" />
    </li>
  );
}

function MaterialCard({ materialType = {}, displayMode, externalModalDiv = null, positionModal }) {
  const {
    title = "",
    image = "",
    link = {},
    icons: materialIcons = [],
    doesAccessRecyclingExists = false,
    isMadeWithRenewableResources = false,
    isCommerciallyCompostable = false,
    hasRecycledContent = false,
    isSourceReduced = false,
  } = materialType;

  try {
    const getLabel = (key) => {
      switch (key) {
        case "accessRecyclingExists":
          return window.globalProperties?.[GLOBAL_PROPS.MATERIAL_LISTING.ACCESS_RECYCLING_LABEL];
        case "commerciallyCompostable":
          return window.globalProperties?.[
            GLOBAL_PROPS.MATERIAL_LISTING.COMMERCIAL_COMPOSTING_LABEL
          ];
        case "containsRecycledContent":
          return window.globalProperties?.[GLOBAL_PROPS.MATERIAL_LISTING.CONTAINS_RECYCLABES_LABEL];
        case "madeWithRenewableResources":
          return window.globalProperties?.[GLOBAL_PROPS.MATERIAL_LISTING.RENEWABLE_RESOURCES_LABEL];
        case "sourceReduced":
          return window.globalProperties?.[GLOBAL_PROPS.MATERIAL_LISTING.SOURCE_REDUCED_LABEL];
        default:
          return "";
      }
    };

    const attributes = {
      containsRecycledContent: { checked: hasRecycledContent },
      accessRecyclingExists: { checked: doesAccessRecyclingExists },
      madeWithRenewableResources: {
        checked: isMadeWithRenewableResources,
      },
      commerciallyCompostable: { checked: isCommerciallyCompostable },
      sourceReduced: { checked: isSourceReduced },
    };

    const labeledAttributes = Object.entries(attributes).map(({ 0: key, 1: value }) => {
      value.label = getLabel(key);
      return value;
    });

    const showCta = link.externalLink || link.internalLink;
    const viewAllLabel = link["label"] ? link.label : window.globalProperties?.[GLOBAL_PROPS.MATERIAL_LISTING.VIEW_ALL_BUTTON_LABEL];

    const detailsContainer = () => {
      const content = (
        <div className="material-card__body__content-wrapper">
            <div className="material-card__body__content">
              
              {labeledAttributes.length > 0 && (
                <>
                  {labeledAttributes.map(({ checked, label }, index) => {
                    return (
                      <MaterialAttribute key={`${label}-${index}`} checked={checked} label={label} />
                    );
                  })}
                </>
              )}
            </div>
            <div className={`material-card__body__material-type-icons__wrapper ${displayMode}`}>
              {materialIcons.length > 0 && (
                <ul className="material-card__body__material-type-icons">
                  {materialIcons.map((name, index) => (
                    <MaterialIcon name={name} key={index} />
                  ))}
                </ul>
              )}
              {showCta && (
                <Desktop>
                  <LinkWrapper
                    className="material-card__body__material-type-icons__wrapper__button btn btn--primary"
                    link={link}
                  >
                    {viewAllLabel}
                  </LinkWrapper>
                </Desktop>
              )}
            </div>
        </div>
      );
      return content;
    };

    const renderCardContent = (renderDetails = false) => (
      <div className={`material-card__wrapper ${displayMode}`}>
        <div className="material-card__media">
          <Image className="material-card__media__image" src={image} alt="" loading="lazy" />
        </div>
        <div className="material-card__body">
          <h2 className="material-card__body__title bold-extra-bold">{title}</h2>
            {displayMode !== DISPLAYMODE.GRIDCOMPACT || renderDetails ? (
              detailsContainer()
            ) : ""}
          {showCta && (
            <Mobile>
              <LinkWrapper
                className="btn btn--primary material-card__media__button"
                link={link}
              >
                {viewAllLabel}
              </LinkWrapper>
            </Mobile>
          )}
        </div>
      </div>
    );

    return (
      <SearchCard
        className="material-card"
        displayMode={displayMode}
        enableHoverModal={true}
        externalModalDiv={externalModalDiv}
        positionModal={positionModal}
        renderContent={renderCardContent}
      />
    );

  } catch (e) {
    return (
      <ErrorComponent
        error={e}
        componentName={MaterialCard.displayName || MaterialCard.name}
      />
    );
  }
}

export default MaterialCard;
